import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
    }

    :root {
        --white: #f9f9f9;
        --ghost-white: #f8f8ff;
        --mint-cream: #f5fffa;
        --snow-flurry: #e8f0c8;
        --fair-pink: #ece3de;
        --matterhorn: #4c4c4c;
        --soft-amber: #d7bda2;
        --autumn-fern: #517649;
        --amber: #ffbf00;
        --seal-brown: #470b00;
        --black-pearl: #10191e;
    }

    body {
        background-color: var(--black-pearl);
        color: var(--black-pearl);
        font-family: 'Roboto Mono', monospace;
        /* font-family: 'PT Serif', serif; */
    }

    #root {
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        align-content: center;
    }

    button {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }
`;
